export default __webpack_public_path__ + "static/media/switch_account.46612e44.svg";